import React, { Component } from 'react'
import { connect } from 'react-redux';
import AsLegendCategory from './airship-wrappers/AsLegendCategory'
import { withCarto } from '../carto/withCarto';

class DpsLegendCategory extends Component {
  state = {
    data: []
  }

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.CartoContext.layers[this.props.layer].on('metadataChanged', this.updateLegendData)
  }

  componentWillUnmount() {
    this.props.CartoContext.layers[this.props.layer].off('metadataChanged', this.updateLegendData)
  }

  updateLegendData = (event) => {
    let data;
    event.styles.forEach(function (styleMetadata) {
      data = styleMetadata.getCategories().map(cat => ({type: 'point', label: cat.name, color: cat.value}))
    });
    this.setState(state => ({
      ...state,
      data: data
    }))
  }

  render() {
    return (
      <AsLegendCategory ref={this.ref} data={this.state.data} slot="legends" orientation="vertical"></AsLegendCategory>
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(DpsLegendCategory));
